import Plane from "../_app/cuchillo/3D/Plane";
import Text3D from "../_app/cuchillo/3D/Text3D";
import { GetBy } from "../_app/cuchillo/core/Element";
import Box from "./Box";

export default class BoxInitial extends Box {
  constructor(__dom) {
    super(__dom);

    const text = GetBy.selector('[data-text]', __dom)[0];
    const text3D = new Text3D({ dom: text, text: text.dataset.text });
    this.add(text3D);
    this.items.push(text3D);
  }
}
